import moment from 'moment';
import React, { Component } from 'react';
import { Datos_Empresa, development } from "../../../libs/utils/Const";
const momentTz = require('moment-timezone');
const formatNumber = {
    separador: ',',
    sepDecimal: '.',

    formatear(num) {
        num += '';
        const splitStr = num.split('.');
        let splitLeft = splitStr[0];
        const splitRight =
            splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';

        const regx = /(\d+)(\d{3})/;

        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(
                regx,
                '$1' + this.separador + '$2'
            );
        }

        return this.simbol + splitLeft + splitRight;
    },

    new(num, simbol) {
        this.simbol = simbol || '';

        if (typeof num === 'undefined') num = 0;
        if (isNaN(num)) return num;

        return this.formatear(Number(num).toFixed(2));
    },
};

class CierreCaja extends Component {

    renderOperaciones = (operaciones, cobranzaDia, otrosMovimientos, total, disponibleBancos) => {

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', }}>
                <thead>
                    <tr>
                        <th style={{ borderBottom: '1px solid #000', padding: '2px', textAlign: 'center', fontWeight: 'bold', }}>
                            Operaciones
                        </th>
                        <th style={{ borderBottom: '1px solid #000', padding: '2px', textAlign: 'right', fontWeight: 'bold', }}>
                            Monto
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ padding: '2px 5px' }}>
                            + PAGO CUENTA OTROS
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(operaciones?.pagoCuentaOtros || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px' }}>
                            + PERCEPCION CONTADO
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(operaciones?.percepcionContado || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px' }}>
                            + VENTA AL CONTADO
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(operaciones?.ventaContado || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px' }}>
                            VENTA AL CREDITO
                        </td>

                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(operaciones?.ventaCredito || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px', fontWeight: 'bold', }}>
                            COBRANZA DEL DIA
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', fontWeight: 'bold', }}>
                            {formatNumber.new(cobranzaDia?.total || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '1px 15px' }}>
                            + CESION USO CONTADO
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(cobranzaDia?.cesionUsoContado || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '1px 15px' }}>
                            - AJUSTE X REDONDEO -
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(cobranzaDia?.ajusteRedondeo || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '1px 15px' }}>
                            - PAGO IZIPAY
                        </td>

                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(cobranzaDia?.pagoIzipay || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '1px 15px' }}>
                            - PAGO IZIPY LINK
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', }}>
                            {formatNumber.new(cobranzaDia?.pagoIzipayLink || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px', fontWeight: 'bold', }}>
                            OTROS MOVIMIENTOS
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', fontWeight: 'bold', }}>
                            {formatNumber.new(otrosMovimientos || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px', fontWeight: 'bold', }}>
                            Total
                        </td>
                        <td style={{ textAlign: 'right', padding: '2px 5px', fontWeight: 'bold', }}>
                            {formatNumber.new(total || 0)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '2px 5px', fontWeight: 'bold', }}>
                            Disponible en Bancos
                        </td>

                        <td style={{ textAlign: 'right', padding: '2px 5px', fontWeight: 'bold', }}>
                            {formatNumber.new(disponibleBancos || 0)}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    render() {
    const { DocsToPrint, ReportsModel } = this.props;
    const doc = DocsToPrint[0];
    const { currentUser, operaciones = {}, cobranzaDia = {}, otrosMovimientos = 0, total = 0, disponibleBancos = 0, estadoCobranza = 'CERRADA', diferencia = 0, itemsVendidos = [], depositos = [], cobranzas = [], tipoCambio = '3.45', venta = 0, cUso = 0, totalVenta = 0 } = doc;
    const totalSoles = depositos.reduce((acc, dep) => acc + Number(dep.Soles || 0), 0);
    const totalDolares = depositos.reduce((acc, dep) => acc + Number(dep.Dolares || 0), 0);
    const totalEnSoles = totalSoles + totalDolares * Number(tipoCambio || 0);
    const totalCantidad = itemsVendidos.reduce((acc, item) => acc + Number(item.Cantidad || 0), 0);
    const totalKilos = itemsVendidos.reduce((acc, item) => acc + Number(item.Kilos || 0), 0);

        return (
            <div style={{ width: 'auto', margin: '0 auto', backgroundColor: '#FFF', color: '#000', fontFamily: 'Arial', fontSize: '11px', padding: '15px', }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed', }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '33.33%', verticalAlign: 'top', }}>
                                <img style={{width: '60%'}} src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt='logo' />
                            </td>
                            <td style={{ width: '33.33%', textAlign: 'center', verticalAlign: 'top', }}>
                                <div style={{ fontSize: '15px', fontWeight: 'bold', }}>
                                    Reporte de Cierre de Caja
                                </div>
                                <div style={{ marginTop: '2px', fontSize: '11px', }}>
                                    Del{' '}{moment(ReportsModel.InitialDate).utc().format('DD/MM/YYYY')}
                                </div>
                            </td>
                            <td style={{ width: '33.33%', textAlign: 'right', verticalAlign: 'top', fontSize: '11px', lineHeight: '16px', }}>
                                <div>
                                    Fecha Imp :{' '}{moment().format('DD/MM/YYYY')}
                                </div>
                                <div>
                                    Hora Imp :{' '}{momentTz().tz('America/Lima').format('hh:mm:ss a')}
                                </div>
                                <div>
                                    #Pag/Total :{' '} 1 / 2
                                </div>
                                <div>
                                    Usuario Imp :{' '}{currentUser?.USER_CODE || ''}
                                </div>
                                <div>
                                    Planta :{' '}{ReportsModel?.NombrePlanta || currentUser?.Branch?.ProjectCode || ''}
                                </div>
                                <div>
                                    Sucursal :{' '}{ReportsModel?.NombreSucursal || currentUser?.Branch?.BranchName || ''}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table style={{ width: '100%', marginTop: '5px', borderCollapse: 'collapse', }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '20px', fontSize: '11px', }}>
                                Empresa: {' '}{Datos_Empresa.Nombre}
                            </td>
                            <td style={{ width: '130px', fontSize: '11px', }}>
                                Reporte:{' '}R29
                            </td>
                        </tr>
                        <tr>
                            <td style={{ paddingTop: '3px', fontSize: '11px', }}>
                                Sucursal:{' '}{ReportsModel?.NombreSucursal || currentUser?.Branch?.BranchName || ''}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '2px', marginLeft: '-80px', textAlign: 'center' }}>
                    Para esta sección solo se mostrarán 15 items
                </div>
                <table style={{ width: '100%', marginTop: '8px', borderCollapse: 'collapse',}}>
                    <tbody>
                        <tr>
                            <td style={{ width: '30%', border: '1px solid #777', verticalAlign: 'top', height: '365px', padding: '10px', }}>
                                {this.renderOperaciones(operaciones, cobranzaDia, otrosMovimientos, total, disponibleBancos)}
                            </td>
                            <td style={{ width: '70%', verticalAlign: 'top', }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ width: '70%', border: '1px solid #777', verticalAlign: 'top', height: '215px', padding: '10px'}}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse', }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ padding: '2px', textAlign: 'left', fontSize: '11px', fontWeight: 'bold', }}>
                                                                Producto
                                                            </th>
                                                            <th style={{ padding: '2px', textAlign: 'right', fontSize: '11px', fontWeight: 'bold', }}>
                                                                Cantidad
                                                            </th>
                                                            <th style={{ padding: '2px', textAlign: 'right', fontSize: '11px', fontWeight: 'bold', }}>
                                                                Kilos
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {itemsVendidos.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ padding: '2px', fontSize: '11px', whiteSpace: 'normal' }}>
                                                                    {item.ItemName}
                                                                </td>
                                                                <td style={{ padding: '2px', textAlign: 'right', fontSize: '11px', }}>
                                                                    {formatNumber.new(item.Cantidad || 0)}
                                                                </td>
                                                                <td style={{ padding: '2px', textAlign: 'right', fontSize: '11px', }}>
                                                                    {formatNumber.new(item.Kilos || 0)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        <tr>
                                                            <td style={{ padding: '2px', fontWeight: 'bold', fontSize: '11px', }}>
                                                                T.GENERAL
                                                            </td>
                                                            <td style={{ padding: '2px', textAlign: 'right', fontWeight: 'bold', fontSize: '11px', }}>
                                                                {formatNumber.new(totalCantidad)}
                                                            </td>
                                                            <td style={{ padding: '2px', textAlign: 'right', fontWeight: 'bold', fontSize: '11px', }}>
                                                                {formatNumber.new(totalKilos)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td style={{ width: '30%', verticalAlign: 'top', paddingLeft: '3px', }}>
                                                <div style={{ border: '1px solid #777', height: '170px', padding: '10px', }}>
                                                    <div style={{ fontSize: '11px', marginBottom: '16px', }}>
                                                        Transito
                                                        <span style={{ float: 'right', }}>
                                                            {formatNumber.new(0)}
                                                        </span>
                                                    </div>
                                                    <div style={{ fontSize: '11px', marginBottom: '16px', }}>
                                                        Venta
                                                        <span style={{ float: 'right', }}>
                                                            {formatNumber.new(venta || 0)}
                                                        </span>
                                                    </div>
                                                    <div style={{ fontSize: '11px', marginBottom: '26px', }}>
                                                        C.Uso
                                                        <span style={{ float: 'right', }}>
                                                            {formatNumber.new(cUso || 0)}
                                                        </span>
                                                    </div>
                                                    <div style={{ fontWeight: 'bold', fontSize: '11px', }}>
                                                        TOTAL:
                                                        <span style={{ float: 'right', }}>
                                                            {formatNumber.new(totalVenta || 0)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div style={{ textAlign: 'center', marginTop: '55px', }}>
                                                    <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px', }}>
                                                        Estado Cobranza :
                                                    </div>
                                                    <div style={{ color: 'blue', fontWeight: 'bold', fontSize: '12px', textAlign: 'center', marginBottom: '25px', }}>
                                                        {estadoCobranza}
                                                    </div>
                                                    <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px', }}>
                                                        Diferencia :
                                                    </div>
                                                    <div style={{ color: 'blue', fontWeight: 'bold', fontSize: '12px', textAlign: 'center', }}>
                                                        {formatNumber.new(diferencia || 0)}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table style={{ width: '100%', marginTop: '4px', border: '1px solid #777', borderCollapse: 'collapse', }} >
                                    <thead>
                                        <tr>
                                            <th style={{ padding: '2px', borderBottom: '1px solid #777', textAlign: 'center', fontSize: '11px', }}>
                                                Depósito
                                            </th>
                                            <th style={{ padding: '2px', borderBottom: '1px solid #777', textAlign: 'right', fontSize: '11px', }}>
                                                Soles
                                            </th>
                                            <th style={{ padding: '2px', borderBottom: '1px solid #777', textAlign: 'right', fontSize: '11px', }}>
                                                Dólares
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {depositos.map((dep, index) => (
                                            <tr key={index}>
                                                <td style={{ padding: '2px 5px', fontSize: '11px', }}>
                                                    {dep.Banco}
                                                </td>
                                                <td style={{ padding: '2px 5px', textAlign: 'right', fontSize: '11px', }}>
                                                    {formatNumber.new(dep.Soles || 0)}
                                                </td>
                                                <td style={{ padding: '2px 5px', textAlign: 'right', fontSize: '11px', }}>
                                                    {formatNumber.new(dep.Dolares || 0)}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr style={{ borderTop: '1px solid #777', fontWeight: 'bold' }}>
                                            <td style={{ padding: '2px 5px', fontSize: '11px' }}>T.C &nbsp;&nbsp; {tipoCambio} &nbsp;&nbsp; Totales :</td>
                                            <td style={{ padding: '2px 5px', textAlign: 'right', fontSize: '11px' }}>{formatNumber.new(totalSoles)}</td>
                                            <td style={{ padding: '2px 5px', textAlign: 'right', fontSize: '11px' }}>{formatNumber.new(totalDolares)}</td>
                                        </tr>
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td style={{ padding: '2px 5px', fontSize: '11px', textAlign: 'right' }}>Total en Soles :</td>
                                            <td style={{ padding: '2px 5px', textAlign: 'right', fontSize: '11px' }}>{formatNumber.new(totalEnSoles)}</td>
                                            <td />
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table style={{ width: '100%', marginTop: '8px', borderCollapse: 'collapse', fontSize: '11px', }}>
                    <thead>
                        <tr>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '40px', fontWeight: 'bold', }}>
                                Nro
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '75px', fontWeight: 'bold', }}>
                                Fecha
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '120px', fontWeight: 'bold', }}>
                                Forma Pago
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '140px', fontWeight: 'bold', }}>
                                Nro.Op./Comp.
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '240px', fontWeight: 'bold', }}>
                                Banco
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', fontWeight: 'bold', }}>
                                Detalle
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '90px', fontWeight: 'bold', }}>
                                S/.
                            </th>
                            <th style={{ borderTop: '1px solid #222', borderBottom: '1px solid #222', padding: '2px 3px', textAlign: 'center', width: '70px', fontWeight: 'bold', }}>
                                $
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan={8} style={{ paddingTop: '4px', paddingBottom: '2px', fontWeight: 'bold', fontSize: '11px', }}>
                                B1. Cobranzas
                            </td>
                        </tr>
                        {cobranzas.map((item, index) => (
                            <tr key={index}>
                                <td style={{ padding: '3px 2px', textAlign: 'center', verticalAlign: 'top', }}>
                                    {index + 1}
                                </td>
                                <td style={{ padding: '3px 2px', verticalAlign: 'top', }}>
                                    {item.Fecha}
                                </td>
                                <td style={{ padding: '3px 2px', verticalAlign: 'top', }}>
                                    {item.FormaPago}
                                </td>
                                <td style={{ padding: '3px 2px', verticalAlign: 'top', }}>
                                    {item.NroOperacion}
                                </td>
                                <td style={{ padding: '3px 2px', verticalAlign: 'top', whiteSpace: 'nowrap', }}>
                                    {item.Banco}
                                </td>
                                <td style={{ padding: '3px 2px', verticalAlign: 'top', whiteSpace: 'nowrap', }}>
                                    {item.Detalle}
                                </td>
                                <td style={{ padding: '3px 2px', textAlign: 'right', verticalAlign: 'top', }}>
                                    {formatNumber.new(item.Soles || 0)}
                                </td>
                                <td style={{ padding: '3px 2px', textAlign: 'right', verticalAlign: 'top', }}>
                                    {formatNumber.new(item.Dolares || 0)}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={6} style={{ paddingTop: '25px', textAlign: 'right', fontWeight: 'bold', fontSize: '11px', }}>
                                Total General :
                            </td>

                            <td style={{ paddingTop: '25px', textAlign: 'right', fontWeight: 'bold', fontSize: '11px', }}>
                                {formatNumber.new(cobranzas.reduce((acc, item) => acc + Number(item.Soles || 0), 0))}
                            </td>
                            <td style={{ paddingTop: '25px', textAlign: 'right', fontWeight: 'bold', fontSize: '11px', }}>
                                {formatNumber.new(cobranzas.reduce((acc, item) => acc + Number(item.Dolares || 0), 0))}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div style={{ marginTop: '70px', width: '100%', }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '50%', verticalAlign: 'top', paddingLeft: '40px', }}>
                                    <div style={{ borderTop: '1px solid #555', width: '410px', marginBottom: '8px', }} />
                                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '11px', lineHeight: '18px', width: '410px', }}>
                                        Asistente de Liquidación
                                        <br />
                                        Responsable
                                    </div>
                                    <table style={{ marginTop: '18px', fontSize: '11px', fontWeight: 'bold', }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ paddingBottom: '14px', width: '140px', }}>
                                                    Nombre y Apellido
                                                </td>
                                                <td>
                                                    :
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    DNI
                                                </td>
                                                <td>
                                                    :
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td style={{ width: '50%', verticalAlign: 'top', paddingLeft: '80px', }}>
                                    <div style={{ borderTop: '1px solid #555', width: '460px', marginBottom: '8px', }} />
                                    <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '11px', width: '460px', }}>
                                        Responsable del Cierre
                                    </div>
                                    <table style={{ marginTop: '22px', fontSize: '11px', fontWeight: 'bold', }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ paddingBottom: '14px', width: '140px', }}>
                                                    Nombre y Apellido
                                                </td>
                                                <td>
                                                    :
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    DNI
                                                </td>
                                                <td>
                                                    :
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default CierreCaja;